import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=04c68962&scoped=true&"
import script from "./InputNumber.vue?vue&type=script&lang=js&"
export * from "./InputNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputNumber.vue?vue&type=style&index=0&id=04c68962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c68962",
  null
  
)

export default component.exports